import React from 'react';
import { Offcanvas } from 'reactstrap';
import { TypedMemo } from '../../../common/types';
import { LoadingView } from '../../../common/views/LoadingView';
import { ErrorView } from '../../../common/views/ErrorView/ErrorView';
import { useTargetDetail } from '../hooks/useTargetDetail';
import type { ReleaseOption } from '../hooks/useReleaseOptions';
import { TargetDrawerBody } from './TargetDrawerBody';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the whole Outreach area; each part uses its own slice of it */
import styles from './Find.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface TargetDrawerProps {
  accountId: number;
  targetUuid: string | null;
  song: ReleaseOption | null;
  onClose: () => void;
}

/** The target drawer over Find (design outreach c2). */
const TargetDrawerComponent: React.FC<TargetDrawerProps> = ({ accountId, targetUuid, song, onClose }) => {
  const { detail, isLoading, error, retry } = useTargetDetail(accountId, targetUuid);
  return (
    <Offcanvas isOpen={targetUuid !== null} toggle={onClose} direction="end" className={styles.drawer}>
      <div className={styles.drawerInner} data-testid="target-drawer">
        {isLoading && <LoadingView />}
        {!isLoading && error !== null && <ErrorView error={error ?? undefined} retry={retry} />}
        {detail !== undefined && (
          <TargetDrawerBody accountId={accountId} detail={detail} song={song} onClose={onClose} />
        )}
      </div>
    </Offcanvas>
  );
};

export const TargetDrawer = TypedMemo(TargetDrawerComponent);
